import _ from 'lodash'
import {$uc} from './axios.setup'

// getNuonMomentList
// - 2025.05.05
// get all nuon moment
export async function getNuonMomentList ({params = {}} = {}) {
  try {
    const url = '/nuoCircle/lists'
    const res = await $uc.get(url, {
      params: _.omit(params, 'hasUser'),
    })

    if (!res) {
      return
    }

    if (res.status === 200) {
      return res.data
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    throw new Error(err.message || err)
  }
}

// getNuonMomentTopics
// - 2025.05.07
// - Fetch list of topics for nuon moment index
export async function getNuonMomentTopics () {
  try {
    const url = '/nuoCircleTheme/lists'
    const res = await $uc.post(url)

    if (!res) {
      return
    }

    if (res.status === 200) {
      return res.data
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    throw new Error(err.message || err)
  }
}

// getNuonMomentDetail
// - 2025.05.29
// - Fetch single post detail by id
export async function getNuonMomentDetail ({params = {}} = {}) {
  try {
    const url = '/nuoCircle/list'
    const res = await $uc.post(url, params)

    if (!res) {
      return
    }

    if (res.status === 200) {
      return res.data
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    throw new Error(err.message || err)
  }
}

// getNuonMomentUserProfile
// - 2025.06.01
// - Fetch user profile by WeChat unionId
export async function getNuonMomentUserProfile ({params = {}} = {}) {
  try {
    const url = '/nuoCircle/personalHomepage'
    const res = await $uc.get(url, {
      params,
    })

    if (!res) {
      return
    }

    if (res.status === 200) {
      return res.data
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    throw new Error(err.message || err)
  }
}

// getNuonMomentCommentList
// - 2025.07.25
// - Get nuon moment comment list for FAQ functionality
// - Fetches questions and answers for a specific car
export async function getNuonMomentCommentList ({params = {}} = {}) {
  try {
    const url = '/nuoCircleReply/lists'
    const res = await $uc.post(url, params)

    if (!res) {
      return
    }

    if (res.status === 200) {
      return res.data
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    throw new Error(err.message || err)
  }
}

